import { styled } from '@zoopla-eng/zds-components/themes';
import { Box } from '@zoopla-eng/zds-components/box';

export const Heading = styled('h2', {
    color: '$textTitle',
    fontGroup: 'plate',
    marginBottom: '$S300'
});

export const Description = styled('p', {
    margin: 0,
    lineHeight: '$S500',
    fontSize: '$S500',
    pb: '$S500'
});

export const ArticleWrapper = styled(Box, {
    p: '0 $S400',
    '@M100': { pl: 0, pr: 0 }
});

export const CampaignCtaWrapper = styled(Box, {
    margin: '0 $S400',
    '@M100': {
        margin: '0'
    }
});

export const WidgetWrapper = styled('div', {
    paddingBottom: '$M300',
    '@M100': {
        paddingBottom: '$L200'
    }
});
